import { IssueMutation, MutationSource } from '@atlassian/jira-jsis-ec-client';
import type { CardMutation } from '../../../common/types';
import { isCreateMutation, isDeleteMutation } from '../../../common/utils';

export const toIssuesMutation = (mutations: CardMutation[]): IssueMutation[] =>
	mutations.map((mutation) => {
		const { cardId: issueId } = mutation;
		if (isCreateMutation(mutation)) {
			return new IssueMutation(String(issueId), MutationSource.CREATE);
		}
		if (isDeleteMutation(mutation)) {
			return new IssueMutation(String(issueId), MutationSource.DELETE);
		}
		return new IssueMutation(String(issueId), MutationSource.UPDATE);
	});
